<template>
    <div class="row pt-3" style="border-top: 1px dashed rgba(106, 113, 133, 0.3);">
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="Single-Item-Select" type="checkbox" value=""
                        v-model="compState.requiredMemo">
                    <label class="form-check-label" for="Single-Item-Select">Memo Required</label>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="mb-3">
                <label>
                    <h6 class="f-w-700">Memo</h6>
                </label>
                <input v-model="compState.memo" class="form-control" type="text" placeholder="Name" maxlength="32">
            </div>
        </div>
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="ageVerificationRequired" type="checkbox" value=""
                        v-model="compState.ageVerificationRequired">
                    <label class="form-check-label" for="ageVerificationRequired">Age Verification Required</label>
                </div>
            </div>
        </div>
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="noMembershipDiscountAllowed" type="checkbox" value=""
                        v-model="compState.noMembershipDiscountAllowed">
                    <label class="form-check-label" for="noMembershipDiscountAllowed">No Membership Discount
                        Allowed</label>
                </div>
            </div>
        </div>
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="nonDiscountable" type="checkbox" value=""
                        v-model="compState.nonDiscountable">
                    <label class="form-check-label" for="nonDiscountable">Non Discountable</label>
                </div>
            </div>
        </div>
        <div class="col-sm-6 ">
            <div class=" mt-3 checkbox-checked h-100 d-flex h-100 align-items-center">
                <div class="form-check ">
                    <input class="form-check-input" id="nonSurchargeable" type="checkbox" value=""
                        v-model="compState.nonSurchargeable">
                    <label class="form-check-label" for="nonSurchargeable">Non Surchargeable</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, reactive, watch, onMounted } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';

const productStore = useProductsStore()

onMounted(() => {
    if (tempActiveProduct.value?.basic.productNumber) {
        const productGroup = tempActiveProduct.value
        const miscellaneousData = productGroup.miscellaneous
        compState.requiredMemo = miscellaneousData.requiredMemo
        compState.memo = miscellaneousData.memo
        compState.ageVerificationRequired = miscellaneousData.ageVerificationRequired
        compState.noMembershipDiscountAllowed = miscellaneousData.noMembershipDiscountAllowed
        compState.nonDiscountable = miscellaneousData.nonDiscountable
        compState.nonSurchargeable = miscellaneousData.nonSurchargeable
    }
})

const compState = reactive({
    requiredMemo: false,
    memo: '',
    ageVerificationRequired: false,
    noMembershipDiscountAllowed: false,
    nonDiscountable: false,
    nonSurchargeable: false
})


const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        const miscellaneousData = productGroup.miscellaneous
        compState.requiredMemo = miscellaneousData.requiredMemo
        compState.memo = miscellaneousData.memo
        compState.ageVerificationRequired = miscellaneousData.ageVerificationRequired
        compState.noMembershipDiscountAllowed = miscellaneousData.noMembershipDiscountAllowed
        compState.nonDiscountable = miscellaneousData.nonDiscountable
        compState.nonSurchargeable = miscellaneousData.nonSurchargeable
    }
}, { immediate: true });

watch(compState, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        miscellaneous: {
            requiredMemo: newVal.requiredMemo,
            memo: newVal.memo,
            ageVerificationRequired: newVal.ageVerificationRequired,
            noMembershipDiscountAllowed: newVal.noMembershipDiscountAllowed,
            nonDiscountable: newVal.nonDiscountable,
            nonSurchargeable: newVal.nonSurchargeable
        }
    })

}, { deep: true });

</script>

<style scoped lang="scss">
.destination-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1rem;
}

.hover-pointer {
    cursor: pointer;
}

.nav-link {
    color: var(--bs-heading-color);
}
</style>